//  Assets
// ===========================================================

import LOGO from '#assets/img/logo-full.webp'


//  Component
// ===========================================================

export function LogoFull({ className }) {
    return (
        <a 
            href="/"
            rel="noreferrer"
            className={className}
        >
            <img src={LOGO} alt="Footer Logo" />
        </a>
    )
}
